import { NgModule } from '@angular/core';

import { FeatherModule } from 'angular-feather';
import {
  Grid,
  List,
  Edit2,
  FileText,
  AlignLeft,
  Briefcase,
  MessageCircle,
  Tool,
  Clock,
  DollarSign,
  Users,
  Clipboard,
  Truck
} from 'angular-feather/icons';

// Select some icons (use an object, not an array)
const icons = {
  Grid,
  List,
  Edit2,
  FileText,
  AlignLeft,
  Briefcase,
  MessageCircle,
  Tool,
  Clock,
  DollarSign,
  Users,
  Clipboard,
  Truck
};

@NgModule({
  imports: [FeatherModule.pick(icons)],
  exports: [FeatherModule]
})
export class FeatherIconsModule {}
